import { useState } from 'react';
import { Success } from './success';

export const Esia = () => {
  const [isSuccess, setIsSuccess] = useState(false);

  return (
    <>
      {isSuccess ? (
        <Success text="Авторизация прошла успешно" />
      ) : (
        <>
          <div className="flex items-center justify-center  w-40 mb-8"></div>
        </>
      )}
    </>
  );
};
